/* tslint:disable */
/* eslint-disable */
/**
 * NGM Merchant Backend API (APIM)
 * Main API of the Sodexo NGM project
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Transaction claim result code
 * @export
 * @enum {string}
 */

export enum TransactionClaimResultEnum {
    Success = 'SUCCESS',
    Failed = 'FAILED',
    GwFailed = 'GW_FAILED'
}



